import Image, { StaticImageData } from 'next/image';
import { ReactElement } from 'react';

import styles from './HowSellingWithUsWorks.module.scss';

type stepsProps = {
  image: StaticImageData;
  title: ReactElement;
  subtitle: ReactElement;
  index: number;
};

export const HowItWorksBlock = ({
  image,
  title,
  subtitle,
  index,
}: stepsProps) => (
  <div className={styles.howItWorksBlock}>
    <div className={styles.imageContainer}>
      <div className={styles.imageWrapper}>
        <Image
          className={styles.image}
          src={image}
          alt="illustration"
          unoptimized
        />
      </div>
    </div>
    <div className={styles.hiwText}>
      <h2 className="u-typography-h2">
        <span className="u-color-brand u-typography-h2-serif">{index}. </span>
        <>{title}</>
      </h2>
      <div className="u-m-t-xl">
        <>{subtitle}</>
      </div>
    </div>
  </div>
);
